<div><router-view></router-view><div class="global-loading-overlay" v-if="isLoading"><div class="spinner-border text-light" role="status"></div></div></div>